import {
  lender_filter,
  loan_application,
} from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send.ts';

export function checkLoanApplication({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async function checkLoanApplication({
    application,
    lenderIDs,
  }: {
    application: loan_application.LoanApplication;
    lenderIDs?: string[];
  }): Promise<lender_filter.CheckLoanApplicationResponse> {
    return send({
      baseURL,
      token,
      path: `/lender-filter/check/loan-application`,
      method: 'POST',
      body: application,
      searchParams: { lender_id: lenderIDs },
    });
  };
}
